
import { useState, useEffect, useRef, useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";


import { useUser } from "./UserContext";
import { useCoaching } from "./CoachingContext";


export {
  CoachingTestimonialsContextProvider,
  useCoachingTestimonials, useCoachingTestimonialsUpdate
};


const CoachingTestimonialsContext = createContext<any>( null ); // TODO: Properly fill out
const CoachingTestimonialsUpdateContext = createContext<any>( null );


function useCoachingTestimonials() {
  return useContext( CoachingTestimonialsContext );
}

function useCoachingTestimonialsUpdate() {
  return useContext( CoachingTestimonialsUpdateContext );
}






type CoachingTestimonialsContextProps = {
  children?: JSX.Element | JSX.Element[];
}


// TODO: Rename to SubjectContext ??? - But it does only have subjectData out of necessity to get programData
function CoachingTestimonialsContextProvider( {children}: CoachingTestimonialsContextProps ) {
  // Provider handles...

  // ... Creating State
  const navigate = useNavigate();

  const [services, setServices] = useState<any[] | undefined>( undefined );


  const { selectedService } = useCoaching();

  const [ selectedServiceHighlight, setSelectedServiceHighlight ] = useState<any>( undefined );
  
  const [ allowPublicShare, setAllowPublicShare ] = useState<boolean>( true );

  const [ testimonialText, setTestimonialText ] = useState<string>( "" ); 


  const [loading, setLoading] = useState( true );

  const { user } = useUser();


  // ... Updating State
  useEffect( () => {

    const abortController = new AbortController();
    async function getTestimonialData() {
      // ...
      //setServices( newCoachingData.services );
    }

    getTestimonialData();


    setLoading( false );

    return () => {
      abortController.abort();
    }
    // TODO: Will "Loading" as part of Dependency Array cause repeated renders?
  }, []);






  const selectServiceHighlight = ( highlight: string ) => {
    setSelectedServiceHighlight( highlight );
  };

  const updateTestimonialText = ( text: string ) => {
    setTestimonialText( text );
  }

  const toggleAllowPublicShare = () => {
    setAllowPublicShare( !allowPublicShare );
  }


  const submitTestimonial = async () => {

    const testimonialData = {
      selectedService,
      selectedServiceHighlight,

      testimonialText,

      allowPublicShare,
    };

    const scheduleEventsEndpoint = "/api/v1/coaching/content/testimonials";

    // TODO: Move to server-fetch.ts ??
    const result = await fetch( scheduleEventsEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify( testimonialData ),
    });

    if( !result?.ok ) { // TODO: Other/better ERROR HANDLING (?)
      console.error( "ERROR Submitting Testimonial", result.status)
    }

  }


  // ... Persisting State down into Children
  return (
    /* TODO: Split this up into other Contexts, such as one for ScheduleContext -- so not have such long & slightly irrelevant props passed via `value` prop */
    <CoachingTestimonialsContext.Provider value={ {selectedServiceHighlight, testimonialText, allowPublicShare} } >
      <CoachingTestimonialsUpdateContext.Provider value={ {selectServiceHighlight, updateTestimonialText, toggleAllowPublicShare, submitTestimonial} } >

        {
          loading ?
            <h1>Loading...</h1>
          :
            children
        }

      </CoachingTestimonialsUpdateContext.Provider>
    </CoachingTestimonialsContext.Provider>
  )
}


// ================================= HELPERS =================================






/* */
